<template>
  <el-dialog
    title="僅顯示 12小時 內，從叫車紀錄傳送給司機的訊息"
    :visible.sync="vx_isDriverMsgModalOpen"
    :before-close="onClose"
    width="70%"
  >
    <el-table style="width: 100%" height="500" :data="vx_driverMsgModal.list">
      <el-table-column prop="announcer" label="發送人" />
      <el-table-column label="發訊時間與訊息內容">
        <template slot-scope="scope">
          <p>{{ formatDate(scope.row.createdAt) }}</p>
          <p>{{ scope.row.content }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="driver_info" label="呼號/姓名" />
      <el-table-column label="司機點擊時間(回覆時間)">
        <template slot-scope="scope">
          <p>{{ formatDate(scope.row.confirm_date) }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="driver_response" label="回覆內容" />
    </el-table>
    <!--頁籤-->
    <el-row style="margin-top: 1rem">
      <el-col :offset="10">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="onPageChange"
          :current-page="vx_driverMsgModal.paging.currentPage"
          :page-count="vx_driverMsgModal.paging.totalPages"
        />
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import dayjs from 'dayjs'

export default {
  methods: {
    ...mapMutations('hailStateV2', {
      vx_setIsDriverMsgModalOpen: 'setIsDriverMsgModalOpen',
    }),
    ...mapActions('hailStateV2', {
      vx_fetchDriverMsgList: 'fetchDriverMsgList',
    }),
    onClose() {
      this.vx_setIsDriverMsgModalOpen()
    },
    onPageChange(page) {
      this.vx_fetchDriverMsgList(page)
    },
    formatDate(d) {
      return d ? dayjs(d).format('YYYY-MM-DD HH:mm:ss') : null
    },
  },
  computed: {
    ...mapState('hailStateV2', {
      vx_isDriverMsgModalOpen: 'isDriverMsgModalOpen',
      vx_driverMsgModal: 'driverMsgModal',
    }),
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/hailState/components-v2/DriverMsgModal.vue